export default class UpdatePersonRequest {
    id: string = '';
    title: string = '';
    firstName: string = '';
    lastName: string = '';
}

